import { AnalyticsEvent, AnalyticsImplementation, FetchApi } from '@backstage/frontend-plugin-api';
import { toUsageAnalyticsEvent, UsageAnalyticsEvent } from './toUsageAnalyticsEvent';
import { toRequestBodies } from './toRequestBodies';

const EVENTS_URL = 'plugin://usage-analytics/events';
const MAX_BATCH_SIZE = 20;
// Browsers cap the combined body size of in-flight keepalive requests at 64 KiB.
const MAX_REQUEST_BODY_BYTES = 32 * 1024;
const FLUSH_INTERVAL_MS = 5000;

export class UsageAnalyticsClient implements AnalyticsImplementation {
  private queue: UsageAnalyticsEvent[] = [];
  private flushTimer?: ReturnType<typeof setTimeout>;

  constructor(private readonly fetchApi: FetchApi) {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.flush();
      }
    });
  }

  captureEvent(event: AnalyticsEvent) {
    this.queue.push(toUsageAnalyticsEvent(event));

    if (this.queue.length >= MAX_BATCH_SIZE) {
      this.flush();
    } else if (!this.flushTimer) {
      this.flushTimer = setTimeout(() => this.flush(), FLUSH_INTERVAL_MS);
    }
  }

  private flush() {
    clearTimeout(this.flushTimer);
    this.flushTimer = undefined;
    if (this.queue.length === 0) {
      return;
    }

    const events = this.queue;
    this.queue = [];
    for (const body of toRequestBodies(events, MAX_REQUEST_BODY_BYTES)) {
      this.fetchApi
        .fetch(EVENTS_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          // Lets the request complete when the tab is being closed.
          keepalive: true,
        })
        .catch(() => {
          // Analytics must never disturb the user, so failed batches are dropped.
        });
    }
  }
}
